import { useState, useEffect } from "react";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

interface TimerProps {
    start: string,
    duration: number,
    tickInterval?: number,
    paused?: boolean,
    remainingMillisecondsOnPause?: number,
    setRemainingMillisecondsOnPause?: (remainingTime: number) => void,
};

export const Timer = ({ start, duration, remainingMillisecondsOnPause, paused, setRemainingMillisecondsOnPause, tickInterval = 50 }: TimerProps) => {
    const calculateEndTime = () =>
        !!remainingMillisecondsOnPause ?
            dayjs(start).add(remainingMillisecondsOnPause, "millisecond") :
            dayjs(start).add(duration, "minute");

    const calculateRemainingTime = () => dayjs.duration(calculateEndTime().diff(dayjs()));

    const [remainingTime, setRemainingTime] = useState(calculateRemainingTime());

    const setCalculatedRemainingTime = (time: duration.Duration) => {
        setRemainingTime(time);
        if (!!setRemainingMillisecondsOnPause) setRemainingMillisecondsOnPause(time.asMilliseconds());
    };

    useEffect(() => {
        const tick = () => {
            if (!paused) {
                if (calculateRemainingTime().milliseconds() <= 0) {
                    setCalculatedRemainingTime(dayjs.duration(0));
                } else {
                    setCalculatedRemainingTime(calculateRemainingTime());
                }
            }
        };

        const interval = setInterval(tick, tickInterval);

        return () => clearInterval(interval);
    }, [start, duration, tickInterval, paused]);

    const pad = (num: number) => (num.toString().length === 1 ? "0" + num : num);

    const remainingMinutes = remainingTime.hours() * 60 + remainingTime.minutes();

    return (
        <div
            className={`timer-wrapper ${
                remainingTime.asMilliseconds() <= 5 * 60000 && duration >= 10 ? "warning" : ""
            }`}
        >
            <div className="display-time" data-testid="display-time">
                {`${pad(remainingMinutes)}:${pad(remainingTime.seconds())}`}
            </div>
        </div>
    );
};
